import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import useAxiosPrivate from '../../hooks/useAxiosPrivate';
import { adapter4BackendProxy } from '../../Utils/utilsDashboards';
import { SelectComponent } from './ReusableSmallComponents';

function SelectUser({ selectedClientvalue,setSelectedClientvalue,hideAllClientValue}) {
    SelectUser.propTypes = {
        userType: PropTypes.any,
        selectedClientvalue: PropTypes.any,
        setSelectedClientvalue: PropTypes.func,
        hideAllClientValue:PropTypes.any,
    };
    const axiosPrivate = useAxiosPrivate();
    const { i18n } = useTranslation();
    const [selectedClient, setSelectedClient] = useState([]);
    const getAllClient = async () => {
        try {
            const clientList = await adapter4BackendProxy(axiosPrivate,   'getAllListClient');
            if(hideAllClientValue!=true)
                clientList.push({_id: 'all',value:'all', label: 'Tous les clients'});
            console.log(Array.isArray(clientList));
            setSelectedClient(clientList);
        } catch (error) {
            console.log(error.response?.status);
        }
    };
    useEffect(()=>{
        getAllClient();
    },[]);

    return (
        <SelectComponent
            label={i18n.t('Clients')}
            val={selectedClientvalue}
            name='clientsList'
            setVal={(e) => {
                setSelectedClientvalue(e.target.value);
            }}
            listVal={selectedClient}
        />
    );
}

export default SelectUser;
{/*
// ! <AutoComplete must have the original TextField and not just the TextFieldComponent for required fields
<TextFieldComponent
                    {...params}
                    sx={{width:width || '350px',
                        '& > :not(style)': {borderRadius: '8px'},
                    }}
                    size={size || 'medium'}
                    placeholder={placeholder || userType}
                    variant={variant || 'outlined'}
                    name={name}
                /> */}